import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: {
    id: 'pageTitle',
    defaultMessage: 'Custom RNA Oligos'
  }
});
